import React from 'react';
import { Container } from 'reactstrap';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import routeConstants from '../utils/routeConstants';
import i18n from '../utils/i18n';
import HeaderContainerTemplate from '../containers/templates/HeaderContainerTemplate';
import './styles/ErrorPageScreen.scss';

class ErrorPage extends React.Component {
  routeToHome() {
    this.props.dispatch(push(routeConstants.HOME_ROUTE));
  }

  render() {
    const { pathname } = this.props.location;
    return (
      <HeaderContainerTemplate>
        <Container>
          <div className="error-page">
            <h2>
              {pathname === routeConstants.ERROR_PAGE
                ? i18n.t('errorPageScreen.OPS_SORRY')
                : i18n.t('errorPageScreen.PAGE_NOT_FOUND')}
            </h2>
            <h2
              className="please-return-home"
              onClick={ () => this.routeToHome() }
            >
              <strong>
                {i18n.t('errorPageScreen.PLEASE')}
                {' '}
                <span className="return-home">
                  {i18n.t('errorPageScreen.RETURN_HOME')}
                </span>
                {' '}
                {i18n.t('errorPageScreen.AND_TRY_AGAIN')}
              </strong>
            </h2>
          </div>
        </Container>
      </HeaderContainerTemplate>
    );
  }
}

ErrorPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  location: PropTypes.shape({ pathname: PropTypes.string })
};

ErrorPage.defaultProps = {
  location: {
    pathname: ''
  }
};

export default withRouter(connect()(ErrorPage));



// WEBPACK FOOTER //
// ./src/scenes/ErrorPage.js